module.exports = __webpack_public_path__ + "media/images/icon_venn-ad4ab1bb9435c198a58cf454ee621478.svg";